//#region IMPORT
import React from 'react';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
/** Components Import */
import {
  Unstable_Grid2 as Grid,
  Stack,
  Box,
  Card,
  TextField,
  Chip,
  Typography,
  MobileStepper,
  Paper,
  Button,
  TableContainer,
  TableBody,
  Table,
  TableRow,
  TableCell,
} from '@mui/material';
import {
  Save as SaveIcon,
  FileDownload as FileDownloadIcon,
  GetApp as GetAppIcon,
} from '@mui/icons-material';
import dayjs from 'dayjs';
import { useTheme } from '@mui/material/styles';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { Dialog, DatePicker, FRadio } from '../../../../Components/MUIs';
/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
//#endregion

function SER_BASIC_01(props) {
  //#region 변수
  const theme = useTheme();

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <Stack>
          <Card
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'space-between',
              p: 1,
              my: 1,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography sx={{ mr: 1 }}>총 점수</Typography>
              <Chip label="800" sx={{ fontSize: '1.2rem', width: '5vw' }} />
              <Typography sx={{ mr: 1, ml: 1 }}>총 취득 점수</Typography>
              <Chip
                label={Number(props.totalPoint)}
                sx={{ color: 'red', fontSize: '1.2rem', width: '5vw' }}
              />
              <Button
                sx={{ m: 1, color: '#2196F3', borderColor: '#2196F3' }}
                size={Commons.IsMobile() ? 'small' : ''}
                variant="outlined"
                onClick={(e) => {
                  props.navigate('/SeriousAccidentAct');
                }}
              >
                목록
              </Button>
              {/* <Button
                sx={{ m: 1, color: '#1565C0', borderColor: '#1565C0' }}
                size={Commons.IsMobile() ? 'small' : ''}
                variant="outlined"
                startIcon={<FileDownloadIcon fontSize="small" />}
                onClick={() => props.ExcelDownload1?.()}
              >
                엑셀다운로드
              </Button> */}
              <Button
                sx={{ m: 1, color: '#0D47A1', borderColor: '#0D47A1' }}
                size={Commons.IsMobile() ? 'small' : ''}
                variant="outlined"
                startIcon={<GetAppIcon fontSize="small" />}
                onClick={() => props.ExcelDownloadAll?.()}
              >
                일괄 엑셀다운로드
              </Button>
              {/* <Button
                sx={{ m: 1, color: '#2196F3', borderColor: '#2196F3' }}
                size={Commons.IsMobile() ? 'small' : ''}
                variant="outlined"
                onClick={(e) => {
                  props.SearchLogic3();
                }}
              >
                점수표
              </Button> */}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <TextField
                size="small"
                placeholder={
                  !props.dateValue.evaName ||
                  props.dateValue.evaName.trim() === ''
                    ? '평가자'
                    : '평가자 이름'
                }
                required
                value={props.dateValue.evaName}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 20) {
                    props.setDateValue({
                      ...props.dateValue,
                      evaName: value,
                    });
                  }
                }}
                inputProps={{ maxLength: 20 }}
                error={
                  !props.dateValue.evaName?.trim() ||
                  props.dateValue.evaName.length >= 20
                }
                helperText={
                  !props.dateValue.evaName?.trim()
                    ? '필수 입력 항목입니다.'
                    : props.dateValue.evaName.length >= 20
                      ? '최대 20자까지 입력 가능합니다.'
                      : // : `${props.dateValue.evaName.length} / 20`
                        ''
                }
              />
              <DatePicker
                sx={{ width: '200px', mx: 1 }}
                name={'평가일자'}
                type="datePicker"
                defaultValue={
                  props.dateValue.evaDate
                    ? dayjs(props.dateValue.evaDate)
                    : dayjs()
                }
                onChange={(date) => {
                  let changeDate = dayjs(date).format('YYYY-MM-DD');
                  if (date) {
                    // 시간을 제거하고 "yyyy-MM-dd" 형식으로 변환하여 저장
                    props.setDateValue({
                      ...props.dateValue,
                      evaDate: changeDate,
                    });
                  }
                }}
                slotProps={{ textField: { size: 'small' } }}
                currentLocale="ko"
              />
              <Button
                sx={{ m: 1, color: '#2CA900', borderColor: '#2CA900' }}
                size={Commons.IsMobile() ? 'small' : ''}
                variant="outlined"
                onClick={() => props.SaveLogic1()}
              >
                <SaveIcon fontSize={''} />
                저장
              </Button>
            </Box>
          </Card>
          <Card>
            <div
              className="ag-theme-alpine"
              style={{
                width: '100%',
                height: '72vh',
              }}
            >
              <Box sx={{ flexGrow: 1 }}>
                <Paper
                  square
                  elevation={0}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    height: 50,
                    pl: 2,
                    bgcolor: 'background.default',
                  }}
                >
                  <Typography variant="h5">
                    {props.steps[props.activeStep].label}
                  </Typography>
                </Paper>
                <Box
                  sx={{
                    overflowY: 'auto', // 수직 스크롤을 추가하기 위해 설정
                    overflowX: 'hidden', // 수평 스크롤을 숨기기 위해 설정
                    '&::-webkit-scrollbar': {
                      width: '8px', // 스크롤바 너비
                    },
                    '&::-webkit-scrollbar-track': {
                      backgroundColor: '#F3F7F8',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#008b43', // 스크롤바 색상
                      borderRadius: '4px', // 스크롤바 둥글게
                      maxHeight: '10px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#fff', // 호버 상태에서의 스크롤바 색상
                    },
                    px: 2,
                    height: '60vh',
                  }}
                >
                  <React.Fragment>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 200 }} size="small">
                        <colgroup>
                          <col style={{ width: '3%' }} />
                          <col style={{ width: '20%' }} />
                          <col style={{ width: '30%' }} />
                          <col style={{ width: '5%' }} />
                          <col style={{ width: '15%' }} />
                          <col style={{ width: '5%' }} />
                        </colgroup>
                        <TableBody>
                          <TableRow>
                            <TableCell
                              align="center"
                              sx={{
                                borderRight: 1,
                                borderColor: 'divider',
                                fontSize: '16px',
                                backgroundColor: '#F3F7F8',
                              }}
                            >
                              {'소계'}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                borderRight: 1,
                                borderColor: 'divider',
                                fontSize: '16px',
                                backgroundColor: '#F3F7F8',
                              }}
                            >
                              {'평가지표'}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                borderRight: 1,
                                borderColor: 'divider',
                                fontSize: '16px',
                                backgroundColor: '#F3F7F8',
                              }}
                            >
                              {'착안사항'}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                borderRight: 1,
                                borderColor: 'divider',
                                fontSize: '16px',
                                backgroundColor: '#F3F7F8',
                              }}
                            >
                              {'배점'}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                borderRight: 1,
                                borderColor: 'divider',
                                fontSize: '16px',
                                backgroundColor: '#F3F7F8',
                              }}
                            >
                              {'평가'}
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                borderRight: 1,
                                borderColor: 'divider',
                                fontSize: '16px',
                                backgroundColor: '#F3F7F8',
                              }}
                            >
                              {'취득점수'}
                            </TableCell>
                          </TableRow>
                          {props.arrayList
                            .filter(
                              (e) =>
                                e.val1 === (props.activeStep + 1).toString()
                            )
                            .map((_item, _index) => {
                              return (
                                <React.Fragment key={_item.code}>
                                  {props.arrayList2
                                    .filter((e) => e.groupCd === _item.code)
                                    .map((_item2, _index2) => (
                                      <TableRow key={_index2}>
                                        {/* 첫 번째 행에서만 rowSpan을 적용 */}
                                        {_index2 === 0 && (
                                          <>
                                            <TableCell
                                              rowSpan={
                                                props.arrayList2.filter(
                                                  (e) =>
                                                    e.groupCd === _item.code
                                                ).length
                                              }
                                              align="center"
                                              sx={{
                                                borderRight: 1,
                                                borderColor: 'divider',
                                                fontSize: '16px',
                                                backgroundColor: '#fff',
                                              }}
                                            >
                                              {_item.val1 + '-' + (_index + 1)}
                                            </TableCell>
                                            <TableCell
                                              rowSpan={
                                                props.arrayList2.filter(
                                                  (e) =>
                                                    e.groupCd === _item.code
                                                ).length
                                              }
                                              align="center"
                                              sx={{
                                                borderRight: 1,
                                                borderColor: 'divider',
                                                fontSize: '16px',
                                                backgroundColor: '#fff',
                                              }}
                                            >
                                              {_item.codeNm}
                                            </TableCell>
                                          </>
                                        )}
                                        <TableCell
                                          sx={{
                                            borderRight: 1,
                                            borderColor: 'divider',
                                            fontSize: '16px',
                                            backgroundColor: '#fff',
                                          }}
                                        >
                                          <Typography
                                            style={{
                                              whiteSpace: 'pre-line',
                                              fontSize: '0.8rem',
                                            }}
                                          >
                                            {_item2.codeNm}
                                          </Typography>
                                        </TableCell>
                                        {_index2 === 0 && (
                                          <>
                                            <TableCell
                                              rowSpan={
                                                props.arrayList2.filter(
                                                  (e) =>
                                                    e.groupCd === _item.code
                                                ).length
                                              }
                                              align="center"
                                              sx={{
                                                borderRight: 1,
                                                borderColor: 'divider',
                                                fontSize: '16px',
                                                backgroundColor: '#fff',
                                              }}
                                            >
                                              {_item.val2}
                                            </TableCell>
                                          </>
                                        )}
                                        <TableCell
                                          sx={{
                                            borderRight: 1,
                                            borderColor: 'divider',
                                            fontSize: '16px',
                                            backgroundColor: '#fff',
                                            justifyContent: 'center',
                                            display: 'flex',
                                          }}
                                        >
                                          {/* <Checkbox
                                            checked={
                                              props.arrayList2.find(
                                                (obj) =>
                                                  obj.code === _item2.code
                                              )?.check || false
                                            }
                                            onChange={(e) =>
                                              props.HandleCheckboxChange(
                                                _item2,
                                                e.target.checked,
                                                _item
                                              )
                                            }
                                          /> */}
                                          <FRadio
                                            value={
                                              props.arrayList2.find(
                                                (obj) =>
                                                  obj.code === _item2.code
                                              )?.check || '0'
                                            }
                                            onChange={(e) =>
                                              props.HandleCheckboxChange(
                                                _item2,
                                                e,
                                                _item
                                              )
                                            }
                                            items={[
                                              {
                                                name: '양호',
                                                value: 'Y',
                                              },
                                              {
                                                name: '미흡',
                                                value: 'N',
                                              },
                                              {
                                                name: '해당없음',
                                                value: '0',
                                              },
                                            ]}
                                          />
                                        </TableCell>
                                        {_index2 === 0 && (
                                          <>
                                            <TableCell
                                              rowSpan={
                                                props.arrayList2.filter(
                                                  (e) =>
                                                    e.groupCd === _item.code
                                                ).length
                                              }
                                              align="center"
                                              sx={{
                                                borderRight: 1,
                                                borderColor: 'divider',
                                                fontSize: '16px',
                                                backgroundColor: '#fff',
                                              }}
                                            >
                                              {!_item.val3 ? 0 : _item.val3}
                                            </TableCell>
                                          </>
                                        )}
                                      </TableRow>
                                    ))}
                                </React.Fragment>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </React.Fragment>
                </Box>
                <MobileStepper
                  variant="text"
                  steps={props.maxSteps}
                  position="static"
                  activeStep={props.activeStep}
                  nextButton={
                    <Button
                      size="small"
                      onClick={props.HandleNext}
                      disabled={props.activeStep === props.maxSteps - 1}
                    >
                      다음
                      {theme.direction === 'rtl' ? (
                        <KeyboardArrowLeft />
                      ) : (
                        <KeyboardArrowRight />
                      )}
                    </Button>
                  }
                  backButton={
                    <Button
                      size="small"
                      onClick={props.HandleBack}
                      disabled={props.activeStep === 0}
                    >
                      {theme.direction === 'rtl' ? (
                        <KeyboardArrowRight />
                      ) : (
                        <KeyboardArrowLeft />
                      )}
                      이전
                    </Button>
                  }
                />
              </Box>
            </div>
          </Card>
        </Stack>
      </Grid>
      {/* 점수표 팝업 창 */}
      {props.modalToggle1 && (
        <Dialog
          title={'사업장 규모별 평가등급 기준'}
          open={props.modalToggle1}
          onClose={(e) => props.setModalToggle1(false)}
          contentSx={{ display: 'flex', flexDirection: 'column' }}
          fullWidth
          closeButtonName={
            props.lanList.length === 0
              ? ''
              : props.lanList.find(
                  (f) => f.LAN_TYPE === 'CALL' && f.LAN_ID === 'Close'
                ).LAN_NM
          } //닫기
          useSaveButton={false}
          useSaveAfterClose={false}
          maxWidth="md"
          content={
            <div
              className="ag-theme-alpine no-scroll"
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {props.imageFile.mapFiles === '' ? (
                <Typography
                  variant="h6"
                  align="center"
                  sx={{ fontWeight: 'bold' }}
                >
                  {'등록된 사진이 없습니다.'}
                </Typography>
              ) : (
                <Box
                  sx={{
                    //display: "flex",
                    justifyContent: 'center',
                    height: '90%',
                  }}
                >
                  <img
                    id={'fileId'}
                    src={props.imageFile.mapFiles || ''}
                    style={{ maxWidth: '100%' }}
                    alt="점수표 이미지"
                  />
                </Box>
              )}
            </div>
          }
        />
      )}
    </Grid>
  );
}

export default SER_BASIC_01;
